export const MOCK_CYPHER_RESULT = {
	data: {
		graphStore: {
			cypherQueryV2: {
				edges: [
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'docs',
									value: {
										nodes: [
											{
												id: 'ari:cloud:confluence:03c65994-7c18-4cf4-9690-8e219e15acf8:page/3535144812',
												data: {
													title: 'Getting started in Confluence from Jira',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3034750528',
												data: {
													title: 'Switcher FE Ownership Transfer - Kirby to CoreX',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3654223022',
												data: {
													title: 'Progressive rollouts strategy for Media',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3102620919',
												data: {
													title: 'Core Experiences - Home (go/cxp-space)',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/4198072840',
												data: {
													title: 'Mercury x TWG - Project schema description',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/4105909777',
												data: {
													title: 'M1: Tech Strategy & Timelines',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3377564806',
												data: {
													title: 'TechOps Reports',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/4030923997',
												data: {
													title: 'test gifs',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/4007333160',
												data: {
													title: 'Upskilling in TWG Tech stack',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3747028766',
												data: {
													title: 'vNext On-Boarding - Provisioning/USM (old)',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3962588918',
												data: {
													title: 'CoreExp - FY25-Q1-S2 Sprint planning',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3957510758',
												data: {
													title: 'Cost estimates - Media processing improvements',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3946791148',
												data: {
													title: '1-pager',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3388955367',
												data: {
													title: 'Unified Storage Management and Tracking',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3852654155',
												data: {
													title: 'Socrates vNext Table Structure',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3943498892',
												data: {
													title: '2024-07-11 - Socrates Data Product Review',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3907551401',
												data: {
													title: 'CoreExp - FY25-Q1-S1 Sprint planning',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3856986584',
												data: {
													title: 'Retro 02/07/24: FY24-Q4-S4',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3905000223',
												data: {
													title: 'E2E tests on Socrates Classic',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3881705487',
												data: {
													title: 'Ash: My user manual',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3856913081',
												data: {
													title: 'CoreExp - FY24-Q4-S4 Sprint planning',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3801815976',
												data: {
													title: 'Revisiting Performance SLOs for Media Image Transformer',
													owner: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:loom:a436116f-02ce-4520-8fbb-7301462a1674:video/activation/1621dc1f-3702-4525-84ba-fad829566798/87633d1322cc487db66a2f6ea16214f2',
												data: {},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/9484784',
												data: {
													summary: 'Tech spec: Logical relationships in UGS',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/9320300',
												data: {
													summary: 'Spike logical groups in UGS',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/9168707',
												data: {
													summary:
														'Improve Trust Score for Risk Assessment: Questionnaire Completion',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8725544',
												data: {
													summary: 'Improve Trust Score for Securely Configured Docker Artifacts',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/9394730',
												data: {
													summary: 'Adopt Golden Renovate Config for auto merging MGI upgrades',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/9325906',
												data: {
													summary:
														'[VULN-1743239] Vulnerability in axios@1.11.0 used by twg-assistant',
													dueDateField: {
														date: '2025-10-15',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3734478',
												data: {
													summary: 'Vulnerability in axios@1.11.0 used by twg-assistant',
													dueDateField: {
														date: '2025-10-15',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/9286010',
												data: {
													summary: 'Improve Trust Score for Compass Data Classification labels',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8981543',
												data: {
													summary: 'DACI: Tech Direction for Ontology and logical grouping ',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8724789',
												data: {
													summary:
														'Improve Trust Score for Infrastructure as Code: Resource Tagging and Repository Attribution',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/9085577',
												data: {
													summary:
														'Create a list of relationships and AGG nodes that can be potentially externalised (TWG Externalisation x Ontology overlap) ',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8647806',
												data: {
													summary:
														'1011269950778921 - socrates-streams-avi_media.usm.ingestion_changed_storage-dev',
													dueDateField: {
														date: '2025-09-30',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8981648',
												data: {
													summary: 'ASOW alignment with Ontology naming conventions',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/9084722',
												data: {
													summary: 'Investigation/thinking: Ontology x Assets ',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/9007987',
												data: {
													summary:
														'[twg-api] Handle cache refresh in cache module instead of Claude module',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8981556',
												data: {
													summary: 'Prep for TWG Tech review on 28/08',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8898083',
												data: {
													summary:
														'• Environment: hello • Request type: ":path": "/gateway/api/graphql/pq/05395b00ac0e7e6656e7091c67274e330a0d5586adb2fcf107ad45e1adbf8d50?operation=useConnectExternalProjectMutation"',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8865260',
												data: {
													summary:
														"Hey !disturbed I'm from Atlassian Home :wave-nya:I got an alert for a spike in unexpected exceptions when fetching project relationships feign.FeignException$InternalServerError: [500 Internal Server Error] during [GET] to [<http://ari-graph-store/api/re…",
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8894085',
												data: {
													summary:
														'Hi !disturbed - We have a use case for Rovo that requires additional fields in the SH events for user link relationships. More details are included in this doc. Who can we work with to get support on the required changes? cc: @unknown',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8864078',
												data: {
													summary:
														'Environment: prod-east Operation: ava.lang.Exception: http response error: repositoryAri=ari:cloud:bitbucket::repository/9ad5c703-33bc-44cc-acbe-e07a31694b36 status=401 UNAUTHORIZED',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8911223',
												data: {
													summary:
														"hi !disturbed :sob:  I've been trying to enable batchQuery on two relationships all week and followed the steps on this page https://hello.atlassian.net/wiki/spaces/TEAMGRAPH/pages/5678559192/AGS+-+How+to+unblock+AGG+schema+change+failures+when+enabling+…",
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8793287',
												data: {
													summary: 'Submit ML ticket to onboard twg assistant to ai-gateway',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8907355',
												data: {
													summary: 'Hi !disturbed - could I please get a review on this small PR ?',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8885202',
												data: {
													summary:
														'Hi !disturbed, our team is looking into building a relationship of where users are assigned or mentioned in an issue (on description or comment) and they have not either replied back with a comment or updated the issue. This is a relationship that we thi…',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8896482',
												data: {
													summary:
														'Hi !disturbed, can I get a quick review of this PR? been through a couple round of revisions so hoping to get this merged while pipelines are passing :please-pib: https://bitbucket.org/atlassian/ari-graph-store/pull-requests/5535',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8863517',
												data: {
													summary:
														'Hello !disturbed is there a way to FG a change to the configuration of a relationship? For example, I would like to make a change to this config to remove the userChecks:... . I would like to do this behind a FG. Please let me know if this is possible, t…',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8867122',
												data: {
													summary:
														'Hi !disturbed I wanted to know if we have an ARI relationship in our TWG for a repository in bitbucket and a component in compass?',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8863865',
												data: {
													summary:
														'hi !disturbed, cc @unknown @unknown , it seems like all query logs in UGS prod have stopped since around 1 am (perhaps due to this pr: https://bitbucket.org/atlassian/ari-graph-store/pull-requests/5536/overview)',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/7094487',
												data: {
													summary: 'ags_prod_activity_ingestion_jira_viewed_issue',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/7094481',
												data: {
													summary: 'ags_prod_activity_ingestion_cf_viewed_page',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8882996',
												data: {
													summary:
														'Hi !disturbed, can I please get a review of this small PR https://bitbucket.org/atlassian/ari-graph-store/pull-requests/5589/overview',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8839225',
												data: {
													summary:
														'Use the Latest Micros Golden Image for node in your service twg-assistant-api',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8746399',
												data: {
													summary: 'Use NVMRC as the version manager',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8711098',
												data: {
													summary: 'twg-assistant-api env:stg-east',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8711097',
												data: {
													summary: 'twg-assistant-api env:stg-east',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8705143',
												data: {
													summary: 'twg-assistant env:stg-east',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/7101429',
												data: {
													summary: 'Ingest activity data from Kamino',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/6617158',
												data: {
													summary: 'Twg - Mercury - M1',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8370110',
												data: {
													summary:
														'ASAP Public Key expiration audit has failed for one or more ASAP public keys you created in environment staging',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8355093',
												data: {
													summary: 'Run main AHF queries first and limit threads on dry-runs',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/7543338',
												data: {
													summary: 'AGG Specific header for Cost Attribution',
													dueDateField: {
														date: '2025-05-31',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/8236040',
												data: {
													summary: 'Decouple Flock shadow calls from returning AHF result to user',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/7528833',
												data: {
													summary: 'PR comments data storage & relationships',
													dueDateField: {
														date: '2025-05-30',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/302407',
												data: {
													summary: 'merged pull requests not updated',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/7762226',
												data: {
													summary: 'Commit Limits -> Get Average number of commits from Plato',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3304780',
												data: {
													summary: 'Fed VULN-250942: CVE-2025-1182 - dt-proc-*',
													dueDateField: {
														date: '2025-07-03',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3304778',
												data: {
													summary: 'Fed VULN-250944: CVE-2025-1176 - dt-proc-*',
													dueDateField: {
														date: '2025-07-03',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3304777',
												data: {
													summary: 'Fed VULN-250945: CVE-2025-1153 - dt-proc-*',
													dueDateField: {
														date: '2025-07-03',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3304779',
												data: {
													summary: 'Fed VULN-250943: CVE-2025-1178 - dt-proc-*',
													dueDateField: {
														date: '2025-07-03',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3304781',
												data: {
													summary: 'Fed VULN-250941: CVE-2025-1181 - dt-proc-*',
													dueDateField: {
														date: '2025-07-03',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3293092',
												data: {
													summary:
														'Fed VULN-245888: CVE-2025-30258 - micros/v1/service/app-switcher-bff:/microservice',
													dueDateField: {
														date: '2025-09-28',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287754',
												data: {
													summary:
														'Fed VULN-243897: CVE-2025-27152 - micros/v1/service/app-switcher-bff:/microservice',
													dueDateField: {
														date: '2025-05-02',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3297585',
												data: {
													summary:
														'Fed VULN-248058: CVE-2024-45338 - micros/v1/service/app-switcher-bff:/platform-tracing-psapi',
													dueDateField: {
														date: '2025-07-01',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3297582',
												data: {
													summary:
														'Fed VULN-248061: CVE-2025-29786 - micros/v1/service/app-switcher-bff:/platform-tracing-psapi',
													dueDateField: {
														date: '2025-05-06',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3297584',
												data: {
													summary:
														'Fed VULN-248059: CVE-2025-22870 - micros/v1/service/app-switcher-bff:/platform-tracing-psapi',
													dueDateField: {
														date: '2025-07-01',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3297583',
												data: {
													summary:
														'Fed VULN-248060: CVE-2025-22869 - micros/v1/service/app-switcher-bff:/platform-tracing-psapi',
													dueDateField: {
														date: '2025-05-06',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3290511',
												data: {
													summary:
														'Fed VULN-245496: CVE-2025-30258 - micros/v1/service/app-switcher-bff:/microservice',
													dueDateField: {
														date: '2025-09-27',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3290317',
												data: {
													summary:
														'Fed VULN-244213: CVE-2025-30258 - micros/v1/service/app-switcher-bff:/platform-service-proxy-ingress',
													dueDateField: {
														date: '2025-09-27',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3290318',
												data: {
													summary:
														'Fed VULN-244212: CVE-2025-30258 - micros/v1/service/app-switcher-bff:/platform-service-proxy-egress',
													dueDateField: {
														date: '2025-09-27',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3290316',
												data: {
													summary:
														'Fed VULN-244214: CVE-2025-30258 - micros/v1/service/app-switcher-bff:/platform-slauth',
													dueDateField: {
														date: '2025-09-27',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/2737534',
												data: {
													summary: 'Vulnerability in koa@2.15.3 used by twg-gql-learn-workshop',
													dueDateField: {
														date: '2025-03-15',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/7190441',
												data: {
													summary:
														'Teamwork Graph - Publish or enrich Bitbucket PR/Commit events for ingesting relationship data into graph',
													dueDateField: {
														date: '2025-05-01',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/294566',
												data: {
													summary:
														'Relationship `confluence_page_shared_with_user` returns no data',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3207349',
												data: {
													summary:
														'Fed VULN-235679: CVE-2024-3596 - micros/v1/service/app-switcher-bff:/platform-statsd-psapi',
													dueDateField: {
														date: '2025-03-25',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3207358',
												data: {
													summary:
														'Fed VULN-235675: CVE-2025-1390 - micros/v1/service/app-switcher-bff:/platform-statsd-psapi',
													dueDateField: {
														date: '2025-06-07',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3207355',
												data: {
													summary:
														'Fed VULN-235676: CVE-2024-12133 - micros/v1/service/app-switcher-bff:/platform-statsd-psapi',
													dueDateField: {
														date: '2025-06-07',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3207347',
												data: {
													summary:
														'Fed VULN-235680: CVE-2025-24528 - micros/v1/service/app-switcher-bff:/platform-statsd-psapi',
													dueDateField: {
														date: '2025-06-07',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3207351',
												data: {
													summary:
														'Fed VULN-235678: CVE-2024-26461 - micros/v1/service/app-switcher-bff:/platform-statsd-psapi',
													dueDateField: {
														date: '2025-04-12',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3207354',
												data: {
													summary:
														'Fed VULN-235677: CVE-2024-26458 - micros/v1/service/app-switcher-bff:/platform-statsd-psapi',
													dueDateField: {
														date: '2025-06-07',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3207362',
												data: {
													summary:
														'Fed VULN-235674: CVE-2025-24528 - micros/v1/service/app-switcher-bff:/platform-slauth',
													dueDateField: {
														date: '2025-06-07',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3207372',
												data: {
													summary:
														'Fed VULN-235671: CVE-2024-26461 - micros/v1/service/app-switcher-bff:/platform-slauth',
													dueDateField: {
														date: '2025-04-12',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3207375',
												data: {
													summary:
														'Fed VULN-235670: CVE-2024-26458 - micros/v1/service/app-switcher-bff:/platform-slauth',
													dueDateField: {
														date: '2025-06-07',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3207365',
												data: {
													summary:
														'Fed VULN-235673: CVE-2025-1390 - micros/v1/service/app-switcher-bff:/platform-slauth',
													dueDateField: {
														date: '2025-06-07',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3207370',
												data: {
													summary:
														'Fed VULN-235672: CVE-2024-12133 - micros/v1/service/app-switcher-bff:/platform-slauth',
													dueDateField: {
														date: '2025-06-07',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/282340',
												data: {
													summary: 'DS - 1P : user-viewed-loom-video',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/283605',
												data: {
													summary: 'DS - 3P - user-viewed-loom-video',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/282338',
												data: {
													summary: 'AGS - user-viewed-loom-video',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/282289',
												data: {
													summary: 'AGS - loom-video-has-loom-comment',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/288228',
												data: {
													summary: 'Data Validation - user-edited-atlas-goal-description',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/288243',
												data: {
													summary: 'Data Validation - user-tagged-in-goal-comment',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/288257',
												data: {
													summary: 'Data Validation - user-created-atlas-goal-learning',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/288264',
												data: {
													summary: 'Data Validation - user-created-atlas-goal-decision',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/288314',
												data: {
													summary: 'Data Validation - user-tagged-in-atlas-project-comment',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/291951',
												data: {
													summary: 'Data Validation - user-tagged-in-atlas-goal-update-comment',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/291959',
												data: {
													summary: 'Data Validation - user-tagged-in-atlas-project-update-comment',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/291965',
												data: {
													summary: 'Data Validation - user-tagged-in-atlas-project-update',
													dueDateField: {
														date: null,
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3113608',
												data: {
													summary:
														'Fed VULN-213969: CVE-2024-12243 - micros/v1/service/app-switcher-bff:/tap-sidecar',
													dueDateField: {
														date: '2025-06-02',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3113606',
												data: {
													summary:
														'Fed VULN-213971: CVE-2025-1390 - micros/v1/service/app-switcher-bff:/tap-sidecar',
													dueDateField: {
														date: '2025-06-02',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3113609',
												data: {
													summary:
														'Fed VULN-213968: CVE-2024-26458 - micros/v1/service/app-switcher-bff:/tap-sidecar',
													dueDateField: {
														date: '2025-06-02',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3113605',
												data: {
													summary:
														'Fed VULN-213972: CVE-2025-24528 - micros/v1/service/app-switcher-bff:/tap-sidecar',
													dueDateField: {
														date: '2025-06-02',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3113607',
												data: {
													summary:
														'Fed VULN-213970: CVE-2024-11053 - micros/v1/service/app-switcher-bff:/tap-sidecar',
													dueDateField: {
														date: '2025-09-01',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3113604',
												data: {
													summary:
														'Fed VULN-213973: CVE-2024-26461 - micros/v1/service/app-switcher-bff:/tap-sidecar',
													dueDateField: {
														date: '2025-04-07',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3113610',
												data: {
													summary:
														'Fed VULN-213967: CVE-2024-3596 - micros/v1/service/app-switcher-bff:/tap-sidecar',
													dueDateField: {
														date: '2025-03-20',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3113620',
												data: {
													summary:
														'Fed VULN-213957: CVE-2024-26461 - micros/v1/service/app-switcher-bff:/platform-statsd-psapi',
													dueDateField: {
														date: '2025-04-07',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3113614',
												data: {
													summary:
														'Fed VULN-213963: CVE-2024-26458 - micros/v1/service/app-switcher-bff:/platform-tcs',
													dueDateField: {
														date: '2025-06-02',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3113632',
												data: {
													summary:
														'Fed VULN-213945: CVE-2025-24528 - micros/v1/service/app-switcher-bff:/platform-metricshostagent',
													dueDateField: {
														date: '2025-06-02',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3113619',
												data: {
													summary:
														'Fed VULN-213958: CVE-2025-1390 - micros/v1/service/app-switcher-bff:/platform-statsd-psapi',
													dueDateField: {
														date: '2025-06-02',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
											{
												id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3113623',
												data: {
													summary:
														'Fed VULN-213954: CVE-2024-12243 - micros/v1/service/app-switcher-bff:/platform-slauth',
													dueDateField: {
														date: '2025-06-02',
													},
													assigneeField: {
														user: {
															name: 'Ashish Kumar',
														},
													},
												},
											},
										],
									},
								},
								{
									key: 'external_docs',
									value: {
										nodes: [],
									},
								},
								{
									key: 'Dataset name',
									value: 'Super sick name',
								},
								{
									key: 'Some value',
									value: 42,
								},
								{
									key: 'Some Boolean',
									value: true,
								},
							],
						},
					},
				],
			},
		},
	},
	extensions: {
		gateway: {
			request_id: '2b7ad5aa-580e-4f45-88e2-cd4feee65caa',
			tId: '2b7ad5aa580e4f4588e2cd4feee65caa',
			crossRegion: true,
			edgeCrossRegion: false,
		},
	},
} as const;
